<!-- Full-page marble background -->
<div class="min-h-screen flex items-center justify-center px-4 py-12"
	style="background-image: url('/images/marble_texture.png'); background-size: cover; background-position: center;">

	<div class="w-full max-w-2xl rounded-lg shadow-2xl overflow-hidden"
		style="border: 6px solid var(--color-sandstone); outline: 1px solid var(--color-gold-500);">

		<div class="flex">

			<!-- Left panel -->
			<div class="shrink-0 relative flex flex-col items-center px-5 text-center"
				style="width: 224px; background-image: url('/images/leftLogin.png'); background-size: cover; background-position: center bottom;">
				<div style="flex: 0 0 8%;"></div>
				<h1 style="font-family: var(--font-family-display); font-size: 1.125rem; font-weight: 600; letter-spacing: 0.12em; line-height: 1.3; color: white; text-shadow: 0 1px 4px rgba(0,0,0,0.6);">
					<span ro-i18n eikey="login.brandName">The Socrates Initiative</span>
				</h1>
				<div style="flex: 0 0 42%;"></div>
				<div style="width: 40px; border-top: 1px solid var(--color-gold-500); margin-bottom: 6px;"></div>
				<p style="font-family: var(--font-family-display); font-size: 0.6rem; font-weight: 500; letter-spacing: 0.18em; text-transform: uppercase; color: var(--color-gold-400); text-shadow: 0 1px 3px rgba(0,0,0,0.5); margin-bottom: 12px; line-height: 1.5;">
					<span ro-i18n eikey="login.brandTagline">Constructive Planning for Results</span>
				</p>
				<div style="flex: 1;"></div>
			</div>

			<!-- Right panel -->
			<div class="flex flex-1 flex-col"
				style="background-image: url('/images/marble_texture.png'); background-size: cover; background-position: center;">

				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />

				<div class="flex flex-1 flex-col justify-center px-10 py-10">

					<h2 class="mb-1 text-2xl font-semibold" style="color: var(--color-charcoal); font-family: var(--font-family-display); letter-spacing: 0.03em;">
						<span ro-i18n eikey="login.passwordReset.title">Reset Password</span>
					</h2>
					<p class="mb-6 text-sm" style="color: var(--color-charcoal); opacity: 0.6; font-family: var(--font-family-ui);">
						<span ro-i18n eikey="login.passwordReset.instruction">Enter your email address and we'll send you a reset code.</span>
					</p>

					<alerts [namespace]="'pwdr'"></alerts>

					<form [formGroup]="resetForm" novalidate (ngSubmit)="onSubmit()" class="space-y-4">

						<div>
							<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
								<span ro-i18n eikey="general.email">Email</span>
							</label>
							<input
								id="id_email_addr"
								formControlName="email"
								name="email"
								type="email"
								class="w-full rounded border px-3 py-2 text-sm outline-none transition-colors"
								style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal); font-family: var(--font-family-ui);"
								[class.border-red-500]="submitted && formControls['email'].errors"
								placeholder="{{ getMessage('login.passwordReset.placeholders.emailPrompt') }}"
							/>
							@if (submitted && formControls['email'].errors?.['required']) {
								<p class="mt-1 text-xs" style="color: var(--color-terra-600);">
									<span ro-i18n eikey="dashboard.password.errorMsgs.emailReq">Email is required</span>
								</p>
							}
							@if (submitted && formControls['email'].errors?.['email']) {
								<p class="mt-1 text-xs" style="color: var(--color-terra-600);">
									<span ro-i18n eikey="dashboard.password.errorMsgs.invalidEmail">Please enter a valid email address</span>
								</p>
							}
						</div>

						<div class="flex gap-3 pt-2">
							<button
								type="submit"
								[disabled]="!resetForm.valid || submitting()"
								class="flex-1 rounded py-2 text-sm font-semibold tracking-wide shadow transition-colors disabled:opacity-50"
								style="background-color: var(--color-aegean-600); color: var(--color-marble); font-family: var(--font-family-display); letter-spacing: 0.06em;">
								@if (submitting()) {
									<span class="flex items-center justify-center gap-2">
										<svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
											<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
											<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
										</svg>
									</span>
								} @else {
									<span ro-i18n eikey="login.passwordReset.resetButton">Send Reset Code</span>
								}
							</button>
							<button
								type="button"
								(click)="onCancel()"
								class="rounded border px-4 py-2 text-sm font-medium transition-colors hover:opacity-80"
								style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal); font-family: var(--font-family-ui);">
								<span ro-i18n eikey="login.passwordReset.cancelButton">Cancel</span>
							</button>
						</div>

					</form>

				</div>

				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />

			</div>
		</div>
	</div>
</div>
